import Link from "next/link";
import Image from "next/image";
import { menuData } from "@/pages/api/menu_data";
import { useState } from "react";
import fetchHeaderFooterData from "@/hooks/fetchHeaderFooterData";
import { TARGET } from "@/utils/constants";

const MobLinks = ({ customClass, data, menuBtn, setMenuactive }) => {

  // get header api data
  const { headerApiData } = fetchHeaderFooterData();
  const mainMenu = (headerApiData?.main_menu) ? headerApiData.main_menu : [];

  const [num, setNum] = useState(0);
  const [menu_data, setMenuData] = useState(menuData);
  const [indexNum_1, setIndexNum_1] = useState(null);
  const [indexNum_2, setIndexNum_2] = useState(null);

  // Define a mapping object for routes and queries
  const routeMapping = {
    // 'bathware': {
    //   pathname: '/bathware/bathware-listing',
    //   query: (name) => (
    //     {
    //       category: name,
    //       from_header: 'yes',
    //     }
    //   ),
    // },
  };

  const menuHandler = (i) => {
    setNum(i);
  };

  const menu_handler_level_1 = (event, i, item) => {
    event.preventDefault();
    event.stopPropagation();
    if (i == indexNum_1) {
      setIndexNum_1(null);
    } else {
      setIndexNum_1(i);
    }
  };

  const menu_handler_level_2 = (event, i) => {
    event.stopPropagation();
    if (i == indexNum_2) {
      setIndexNum_2(null);
    } else {
      setIndexNum_2(i);
    }
  };

  return (
    <ul
      className={`lg:flex justify-center *:uppercase *:lg:text-[0.938vw] *:font-secondary lg:gap-x-[3.333vw] *:lg:py-[1vw] main-nav  ${customClass}`}
    >
      {mainMenu &&
        mainMenu.map((item, index) => {
          return (
            <li
              key={index}
            >
              <div
                className="relative px-5"
              >
                <div
                  className="w-[97%]"
                >
                  <Link
                    onClick={(event) => {
                      menu_handler_level_1(event, index, item)
                      setMenuactive(false)
                    }}
                    className="w-full"
                    href={item.slug ? `${item.slug}` : ""}
                  >
                    {item.name}
                  </Link>
                </div>
                {item.sub_menus && item.sub_menus.length > 0 && (
                  <span
                    onClick={(event) => {
                      menu_handler_level_1(event, index, item)
                    }}
                    className={`${indexNum_1 == index ? "rotate-[180deg]" : ""
                      } absolute right-[1.25rem] top-[3px] w-[20px] transition-all duration-300`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="20"
                      viewBox="0 0 12 9"
                      fill="none"
                      className="w-full h-auto"
                    >
                      <path
                        d="M6 8.3751L0 2.3751L1.4 0.975098L6 5.5751L10.6 0.975098L12 2.3751L6 8.3751Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                )}
              </div>

              {item.sub_menus && item.sub_menus.length > 0 && (
                <ul
                  className={`w-full mt-3 px-5 py-2 bg-[#363435] ${indexNum_1 == index ? "block" : "hidden"}`}
                >

                  {item.sub_menus.map((subItem, i) => (
                    <li
                      key={i}
                      className="py-3"
                    >
                      <div
                        className="relative block capitalize"
                      >{
                          <Link
                            // href={subItem.slug ? `${subItem.slug}` : ""}
                            onClick={(event) => {
                              setMenuactive(false)
                              menu_handler_level_2(event, i)
                            }}
                            href={
                              subItem?.slug?.includes("https")
                                ? subItem.slug
                                : `${subItem.slug}`
                            }
                            target={subItem?.slug?.includes('https') ? TARGET.BLANK : TARGET.SELF}
                          >
                            {subItem.name == "" ? "Category" : subItem.name}
                          </Link>
                        }
                        {subItem.sub_menus.length > 0 && (
                          <span
                            onClick={(event) => {
                              menu_handler_level_2(event, i)
                            }}
                            className="absolute right-0 top-[0px] font-secondary text-[1.1rem]">
                            {indexNum_2 == i ? "-" : "+"}
                          </span>
                        )}
                      </div>
                      {subItem.sub_menus && subItem.sub_menus.length > 0 && (
                        <div
                          className={`bg-black p-4 mt-4 ${indexNum_2 == i ? "block" : "hidden"
                            }`}
                          onClick={() => {
                            setMenuactive(false)
                          }}
                        >
                          {subItem.sub_menus.map((lastItem, j) => (
                            <Link
                              href={lastItem.slug ? `${lastItem.slug}` : ""}
                              // href={
                              //   item.name.toLowerCase() === "tiles"
                              //     ? "/collection"
                              //     : lastItem.slug
                              //       ? `/${lastItem.slug}`
                              //       : ""
                              // }
                              passHref
                              key={j}
                              className="block capitalize px-4 py-3"
                            >
                              {lastItem.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
    </ul>
  );
};

export default MobLinks;
